import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="subscribe-gate"
// Disables the rest of a form's fields until the "subscribe" checkbox is
// checked, so a user can't fill out and save settings for a digest they
// never actually opted into.
export default class extends Controller {
  static targets = ["toggle", "field", "fieldsWrapper"];

  connect() {
    this.sync();
  }

  sync() {
    const enabled = this.toggleTarget.checked;
    this.fieldTargets.forEach((field) => {
      field.disabled = !enabled;
    });
    // Scoped to the fields wrappers, not this.element — the toggle itself
    // lives in this controller's scope too and must stay clickable so it
    // can always be switched back on.
    this.fieldsWrapperTargets.forEach((wrapper) => {
      wrapper.classList.toggle("opacity-50", !enabled);
      wrapper.classList.toggle("pointer-events-none", !enabled);
    });
  }
}
